export const SecurityDeviceIcon = ({
  className,
  strokeColor = 'currentColor',
  size = 48,
}: {
  className?: string
  strokeColor?: string
  size?: number
}) => (
  <svg
    className={className}
    fill='none'
    height={size}
    viewBox='0 0 20 20'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      clipRule='evenodd'
      d='M14.2187 10.1562C16.4911 10.1562 18.3333 11.9984 18.3333 14.2708C18.3333 16.5433 16.4911 18.3854 14.2187 18.3854H5.78121C3.50879 18.3854 1.66663 16.5433 1.66663 14.2708C1.66663 11.9984 3.50879 10.1562 5.78121 10.1562H14.2187ZM5.78121 11.8229C4.42926 11.8229 3.33329 12.9189 3.33329 14.2708C3.33329 15.6228 4.42926 16.7188 5.78121 16.7188H14.2187C15.5707 16.7188 16.6666 15.6228 16.6666 14.2708C16.6666 12.9189 15.5707 11.8229 14.2187 11.8229H5.78121Z'
      fill={strokeColor}
      fillRule='evenodd'
    />
    <path
      d='M10.0699 4.52962C10.9186 4.52962 11.7591 4.69702 12.5431 5.02197C13.327 5.34695 14.0397 5.82295 14.6394 6.42334C14.9647 6.74894 14.9642 7.27646 14.6386 7.60173C14.313 7.92696 13.7855 7.92728 13.4602 7.60173C13.0152 7.15621 12.4868 6.80282 11.9051 6.56169C11.3234 6.32055 10.6996 6.19629 10.0699 6.19629C9.44041 6.19633 8.8172 6.32063 8.23564 6.56169C7.65394 6.80282 7.12547 7.15622 6.68046 7.60173C6.3552 7.92734 5.82688 7.92698 5.50126 7.60173C5.17604 7.27644 5.17614 6.74883 5.50126 6.42334C6.10092 5.82308 6.81302 5.34693 7.5968 5.02197C8.38073 4.697 9.22133 4.52967 10.0699 4.52962Z'
      fill={strokeColor}
    />
    <path
      d='M10.0659 0.78125C12.7727 0.781327 15.3684 1.85665 17.2827 3.77034C17.6081 4.09574 17.608 4.62326 17.2827 4.94873C16.9573 5.27395 16.4297 5.27403 16.1043 4.94873C14.5026 3.34757 12.3307 2.44799 10.0659 2.44792C7.80094 2.44792 5.62845 3.34743 4.02665 4.94873C3.70122 5.27407 3.17367 5.27406 2.84827 4.94873C2.52293 4.6233 2.52293 4.09575 2.84827 3.77034C4.76261 1.85658 7.35899 0.78125 10.0659 0.78125Z'
      fill={strokeColor}
    />
  </svg>
)
